import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface HealthState {
  status: 'idle' | 'loading' | 'healthy' | 'error'
  lastChecked: string | null
  error: string | null
}

const initialState: HealthState = {
  status: 'idle',
  lastChecked: null,
  error: null,
}

const healthSlice = createSlice({
  name: 'health',
  initialState,
  reducers: {
    setHealthStatus: (state, action: PayloadAction<HealthState['status']>) => {
      state.status = action.payload
      state.lastChecked = new Date().toISOString()
    },
    setHealthError: (state, action: PayloadAction<string>) => {
      state.status = 'error'
      state.error = action.payload
    },
  },
})

export const { setHealthStatus, setHealthError } = healthSlice.actions
export default healthSlice.reducer